import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';

const iconMap = new Map<string, string>()
  .set('cable-car-big', 'gondola-big')
  .set('funicular', 'cable-car')
  .set('train', 'cable-car-cog')
  .set('cable-car', 'gondola-small')
  .set('platter-lift', 'chairlift')
  .set('button-lift', 'bowlift')
  .set('slope', 'slope-3');

@Pipe({
  name: 'contentMountainRailway'
})
export class MountainRailwayPipe implements PipeTransform {

  transform(entry: Models.ContentEntry): Models.MountainAreaEntry {

    const mountainRailways: Models.MountainRailwayEntry[] = [];
    const mountainSlopes: Models.MountainSlopeEntry[] = [];

    if (!entry || !entry.detail) {
      return null;
    }

    if (entry.detail.railways) {
      for (const item of entry.detail.railways) {
        const mountainRailway = new Models.MountainRailwayEntry();
        mountainRailway.populateFromJSON({
          title: item.title,
          icon: item.icon,
          statusId: item.statusId,
          id: item.mapId
        });
        if (iconMap.get(item.icon)) {
          mountainRailway.icon = iconMap.get(item.icon);
        }
        mountainRailways.push(mountainRailway);
      }
    }

    if (entry.detail.slopes) {
      for (const item of entry.detail.slopes) {
        const mountainSlope = new Models.MountainSlopeEntry();
        mountainSlope.populateFromJSON({
          title: item.title,
          icon: iconMap.get(item.icon),
          difficulty: item.difficulty,
          statusId: item.statusId,
          id: item.mapId
        });
        mountainSlopes.push(mountainSlope);
      }
    }

    const mountainArea = new Models.MountainAreaEntry();

    const data = {
      sourceId: entry._id,
      railways: mountainRailways || [],
      slopes: mountainSlopes || [],
      miscellaneous: entry.detail.miscellaneous || null,
      lastUpdated: entry.detail.lastUpdated ? Math.round(entry.detail.lastUpdated / 1000) : null
    };

    mountainArea.populateFromJSON(data);

    return mountainArea;
  }
}
